import React, { useEffect, useState } from "react";
import imageCompression from "browser-image-compression";
import { INSPECTION_STATUS } from "../../../../constant/constant";
import parse from "html-react-parser";
import Loader from "../../../../library/common/Loader";

const NewOpenItem = ({ inQuestion }) => {
  const [compressedImages, setCompressedImages] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchImageAsFile = async (url) => {
    if (!url || typeof url !== "string") {
      throw new Error("Invalid or missing image URL");
    }

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch image: ${url}`);
    }

    const blob = await response.blob();
    return new File([blob], "image.jpg", { type: blob.type });
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  useEffect(() => {
    const compressImages = async () => {
      setLoading(true);
      const imagesByLocation = {};

      if (
        inQuestion?.detailsReportView &&
        Array.isArray(inQuestion.detailsReportView)
      ) {
        await Promise.all(
          inQuestion.detailsReportView.map(async (itemDetail, itemDetailIndex) => {
            if (
              itemDetail?.locationsReportView &&
              Array.isArray(itemDetail.locationsReportView)
            ) {
              await Promise.all(
                itemDetail.locationsReportView.map(async (item, locationIndex) => {
                  if (item?.files && Array.isArray(item.files)) {
                    const files = await Promise.all(
                      item.files.map(async (img) => {
                        try {
                          if (!img?.filePath) {
                            console.warn("Skipping image: filePath is missing", img);
                            return null;
                          }

                          const file = await fetchImageAsFile(img.filePath);
                          const compressedFile = await imageCompression(file, {
                            maxSizeMB: 100 / 1024,
                            maxWidthOrHeight: 1920,
                            useWebWorker: true,
                          });

                          const base64 = await fileToBase64(compressedFile);

                          return {
                            filePath: base64,
                            fileId: img.fileId,
                          };
                        } catch (error) {
                          console.warn("Skipping image due to error:", error);
                          return null;
                        }
                      })
                    );

                    const validFiles = files.filter(Boolean);
                    const key = `${itemDetailIndex}-${locationIndex}`;
                    imagesByLocation[key] = validFiles;
                  }
                })
              );
            }
          })
        );
      }

      setCompressedImages(imagesByLocation);
      setLoading(false);
    };

    compressImages();
  }, [inQuestion]);

  return (
    <>
      {loading && <Loader />}
      {inQuestion?.detailsReportView?.map((itemDetail, itemDetailIndex) => (
        <React.Fragment key={itemDetailIndex}>
          {itemDetail?.locationsReportView?.map((item, locationIndex) => {
            const key = `${itemDetailIndex}-${locationIndex}`;
            return (
              <tr className="tableBody" key={key}>
                <td>{item?.location}</td>
                <td>
                  <div className="itemFondText">
                    <span>
                      {itemDetail?.itemFound}
                      {itemDetail?.details && <> - </>}
                    </span>
                    {itemDetail?.details && (
                      <span>{parse(unescape(itemDetail?.details))}</span>
                    )}
                  </div>
                </td>
                <td>
                  {compressedImages[key]?.map((img) => (
                    <img
                      src={img.filePath}
                      alt=""
                      className="imgViewReport"
                      key={img.fileId}
                    />
                  ))}
                </td>
                <td>
                  <div className="statuss">
                    {item?.statusId === INSPECTION_STATUS?.Open ? (
                      <div className="open">Open</div>
                    ) : (
                      <div className="closed">Closed</div>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </React.Fragment>
      ))}
    </>
  );
};

export default NewOpenItem;